import {
  BEWERBERMAPPE,
  CHANCEN_CHECK,
  DEKRA_BAUSCHADENGUTACHTEN,
  DERKA_IMMOBILIENBEWERTUNG,
  EXKLUSIVE_ANZEIGEN,
  IMMOBILIENBEWERTUNG,
  MIETERSCHUTZ,
  NACHBARSCHAFTS,
  OBEN_IM_POSTFACH,
  SCHUFA,
  VORSTELLUNGSMAPPE,
} from '../domain/routes';

export enum Benefit {
  // common plus benefits
  MAGENTA_TV = 'MAGENTA_TV',

  // KAEUFER_PLUS_BENEFITS
  OPPORTUNITY_CHECK = 'OPPORTUNITY_CHECK',
  EXCLUSIVE_LISTINGS = 'EXCLUSIVE_LISTINGS',
  FIRST_IN_INBOX = 'FIRST_IN_INBOX',
  SCHUFA_CHECK = 'SCHUFA_CHECK',
  APPLICATION_PACKAGE = 'APPLICATION_PACKAGE',
  VALUATION = 'VALUATION',
  REAL_ESTATE_PROOF = 'REAL_ESTATE_PROOF',
  REAL_ESTATE_DAMAGE_REPORT = 'REAL_ESTATE_DAMAGE_REPORT',
  LEGAL_INSURANCE = 'LEGAL_INSURANCE',

  // MIETER_PLUS_BENEFITS
  // TODO: The spelling of the POSSIBILITY_CHECK enum value it's on purpose "POSSIBLITY_CHECK" (which is wrongly spelled)
  // as that is the value the BE currently returns. Would we want to fix the spelling it would need to be done on the BE first
  // and then adjusted on the FE.
  POSSIBILITY_CHECK = 'POSSIBLITY_CHECK',
  ADVERTISEMENTS = 'ADVERTISEMENTS',
  MESSENGER = 'MESSENGER',
  DOCUMENTS = 'DOCUMENTS',
  SCHUFA = 'SCHUFA', // MieterPlusSchufa

  // WOHNEN_PLUS_BENEFITS
  DEPOSIT = 'DEPOSIT',
  BILLCHECK = 'BILLCHECK',
  RENT_LEGAL = 'RENT_LEGAL',
  KEY_EMERGENCY = 'KEY_EMERGENCY',
  STORAGE_SERVICE = 'STORAGE_SERVICE',
  RELOCATION_BOX = 'RELOCATION_BOX',
  RELOCATION_SERVICE = 'RELOCATION_SERVICE',
  ADDRESS_CHANGE = 'ADDRESS_CHANGE',
  CALENDAR = 'CALENDAR',
  TENANT_PROTECTION_SERVICE = 'TENANT_PROTECTION_SERVICE',
  RECHTSBERATUNG = 'RECHTSBERATUNG',
  SCHLUESSELDIENST = 'SCHLUESSELDIENST',
  MIETRECHTSSCHUTZ = 'MIETRECHTSSCHUTZ',
  MEDIATION = 'MEDIATION',
}

export const COMMON_PLUS_BENEFITS = [Benefit.MAGENTA_TV, Benefit.ADDRESS_CHANGE];

export const KAEUFER_PLUS_BENEFITS = [
  Benefit.OPPORTUNITY_CHECK,
  Benefit.EXCLUSIVE_LISTINGS,
  Benefit.FIRST_IN_INBOX,
  Benefit.SCHUFA_CHECK,
  Benefit.APPLICATION_PACKAGE,
  Benefit.VALUATION,
  Benefit.REAL_ESTATE_PROOF,
  Benefit.REAL_ESTATE_DAMAGE_REPORT,
  Benefit.LEGAL_INSURANCE,
];

export const MIETER_PLUS_BENEFITS = [
  Benefit.POSSIBILITY_CHECK,
  Benefit.ADVERTISEMENTS,
  Benefit.MESSENGER,
  Benefit.SCHUFA,
  Benefit.DOCUMENTS,
  Benefit.RELOCATION_SERVICE,
  Benefit.ADDRESS_CHANGE,
];

export const WOHNEN_PLUS_BENEFITS = [
  Benefit.DEPOSIT,
  Benefit.RENT_LEGAL,
  Benefit.RELOCATION_BOX,
  Benefit.KEY_EMERGENCY,
  Benefit.BILLCHECK,
  Benefit.STORAGE_SERVICE,
  Benefit.TENANT_PROTECTION_SERVICE,
  Benefit.MEDIATION,
  Benefit.SCHLUESSELDIENST,
  Benefit.RECHTSBERATUNG,
  Benefit.MIETRECHTSSCHUTZ,
];

// @TODO: move logic to src/utils/getBenefitList.util.ts
export const BenefitKeyPath = {
  [Benefit.OPPORTUNITY_CHECK]: CHANCEN_CHECK,
  [Benefit.POSSIBILITY_CHECK]: CHANCEN_CHECK,
  [Benefit.EXCLUSIVE_LISTINGS]: EXKLUSIVE_ANZEIGEN,
  [Benefit.ADVERTISEMENTS]: EXKLUSIVE_ANZEIGEN,
  [Benefit.FIRST_IN_INBOX]: OBEN_IM_POSTFACH,
  [Benefit.MESSENGER]: OBEN_IM_POSTFACH,
  [Benefit.SCHUFA_CHECK]: SCHUFA,
  [Benefit.SCHUFA]: SCHUFA,
  [Benefit.APPLICATION_PACKAGE]: VORSTELLUNGSMAPPE,
  [Benefit.VALUATION]: IMMOBILIENBEWERTUNG,
  [Benefit.REAL_ESTATE_PROOF]: DERKA_IMMOBILIENBEWERTUNG,
  [Benefit.REAL_ESTATE_DAMAGE_REPORT]: DEKRA_BAUSCHADENGUTACHTEN,
  [Benefit.LEGAL_INSURANCE]: NACHBARSCHAFTS,
  [Benefit.STORAGE_SERVICE]: MIETERSCHUTZ,
  [Benefit.DOCUMENTS]: BEWERBERMAPPE,
};
